import { render, staticRenderFns } from "./PurchasesPaymentForm.vue?vue&type=template&id=fbd3d582&"
import script from "./PurchasesPaymentForm.vue?vue&type=script&lang=js&"
export * from "./PurchasesPaymentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports